// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue';
import App from './App';
import router from './router';
import Vuetify from 'vuetify';
import firebase from 'firebase/app';
import 'firebase/auth';
import VueClipboard from 'vue-clipboard2';
import store from './store';
import moment from 'moment';

Vue.config.productionTip = false;

Vue.use(Vuetify);
Vue.use(VueClipboard);

let app;
// Initialize Firebase
let config ={
  apiKey: process.env.FIREBASE_APIKEY,
  authDomain: process.env.FIREBASE_AUTH_DOMAIN,
  databaseURL: process.env.FIREBASE_DB_URL,
  projectId: process.env.FIREBASE_PROJECT_ID,
  storageBucket: process.env.FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.FIREBASE_SENDER_ID
};
firebase.initializeApp(config);
store.dispatch('initCompanies');
store.dispatch('initUsers');
store.dispatch('initMenu');
store.dispatch('initStreams');
store.dispatch('initSubstitutions');
store.dispatch('initPlans');
store.dispatch('initOrders', moment().add(1, 'days'));
firebase.auth().onAuthStateChanged(function(user) {
  if(!app){
    /* eslint-disable no-new */
    app = new Vue({
      el: '#app',
      router,
      store,
      components: { App },
      template: '<App/>'
    });
  }
});



// WEBPACK FOOTER //
// ./src/main.js